import { LOCALES } from '../locales'
import svFI from '../compiled/sv-FI/translation.json'

export default {
	[LOCALES.SWEDISH]: svFI,
}
